import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CssVarsProvider, extendTheme } from "@mui/joy/styles";
import {
    Box,
    Button,
    CssBaseline,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Typography,
} from "@mui/joy";

const LoginPage = ({ onLogin }) => {
    const [roomId, setRoomId] = useState('25bla10aaa225');
    const [password, setPassword] = useState('somepass1');
    const [error, setError] = useState('');
    const navigate = useNavigate(); // Use navigate for redirection

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate if room ID and password are not empty
        if (!roomId || !password) {
            setError('Room ID and password cannot be empty!');
            return;
        }

        // If inputs are valid, perform login
        onLogin(roomId, password); // Set authentication state to true
        navigate('/home', { state: { roomId, password } }); // Pass room ID and password to home page
    };

    const customTheme = extendTheme({ defaultColorScheme: 'dark' });

    return (
        <CssVarsProvider theme={customTheme} disableTransitionOnChange>
            <CssBaseline />
            <Box
                sx={(theme) => ({
                    width: '100%',
                    position: 'center',
                    zIndex: 1,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    backdropFilter: 'blur(12px)',
                    backgroundColor: 'rgba(255 255 255 / 0.2)',
                    [theme.getColorSchemeSelector('dark')]: {
                        backgroundColor: 'rgba(19 19 24 / 0.4)',
                    },
                })}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100dvh',
                        width: '100%',
                        px: 2,
                    }}
                >
                    <Box component="header" sx={{ py: 3 }}>
                        <Typography level="title-lg">AiHub</Typography>
                    </Box>

                    <Box
                        component="main"
                        sx={{
                            my: 'auto',
                            py: 2,
                            pb: 5,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            width: 400,
                            maxWidth: '100%',
                            mx: 'auto',
                            borderRadius: 'sm',
                        }}
                    >
                        <Stack sx={{ gap: 4, mb: 2 }}>
                            <Typography component="h1" level="h3">
                                Sign in
                            </Typography>
                        </Stack>

                        <form onSubmit={handleSubmit}>
                            <FormControl required>
                                <FormLabel>Room ID</FormLabel>
                                <Input
                                    type="text"
                                    value={roomId}
                                    onChange={(e) => setRoomId(e.target.value)}
                                />
                            </FormControl>

                            <FormControl required>
                                <FormLabel>Password</FormLabel>
                                <Input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </FormControl>

                            {error && <Typography color="red">{error}</Typography>}

                            <Stack sx={{ gap: 4, mt: 2 }}>
                                <Button type="submit" fullWidth>
                                    Sign in
                                </Button>
                            </Stack>
                        </form>
                    </Box>
                </Box>
            </Box>
        </CssVarsProvider>
    );
};

export default LoginPage;
